var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBusinesscenter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 38,
    viewBox: "0 0 40 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 37.5C2.71875 37.5 1.83594 37.1328 1.10156 36.3984C0.367188 35.6641 0 34.7812 0 33.75V11.25C0 10.2188 0.367188 9.33594 1.10156 8.60156C1.83594 7.86719 2.71875 7.5 3.75 7.5H10V3.73896C10 2.70465 10.3672 1.82292 11.1016 1.09375C11.8359 0.364583 12.7188 0 13.75 0H26.25C27.2812 0 28.1641 0.367189 28.8984 1.10156C29.6328 1.83594 30 2.71875 30 3.75V7.5H36.25C37.2812 7.5 38.1641 7.86719 38.8984 8.60156C39.6328 9.33594 40 10.2188 40 11.25V33.75C40 34.7812 39.6328 35.6641 38.8984 36.3984C38.1641 37.1328 37.2812 37.5 36.25 37.5H3.75ZM13.75 7.5H26.25V3.75H13.75V7.5ZM36.25 25.625H26.25V28.125C26.25 28.6562 26.0703 29.1016 25.7109 29.4609C25.3516 29.8203 24.9062 30 24.375 30H15.625C15.0938 30 14.6484 29.8203 14.2891 29.4609C13.9297 29.1016 13.75 28.6562 13.75 28.125V25.625H3.75V33.75H36.25V25.625ZM17.5 26.25H22.5V21.25H17.5V26.25ZM3.75 21.875H13.75V19.375C13.75 18.8438 13.9297 18.3984 14.2891 18.0391C14.6484 17.6797 15.0938 17.5 15.625 17.5H24.375C24.9062 17.5 25.3516 17.6797 25.7109 18.0391C26.0703 18.3984 26.25 18.8438 26.25 19.375V21.875H36.25V11.25H3.75V21.875Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinesscenter);
export default __webpack_public_path__ + "static/media/businesscenter.6953a856c18f7eb5585149aa1e93bd25.svg";
export { ForwardRef as ReactComponent };